import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const sourceService = {
    getAllSources,
    updateSourceStatus,
    getSource,
    updateSource,
    createSource,
};

const MODULE = {
    SOURCE: 'rnd-product-sources',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Source') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllSources(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            product: filter.product,
            source: filter.source,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return await apiHelper(API_URL).get(`/${MODULE.SOURCE}`, requestOptions)
}


export function updateSourceStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.SOURCE}/${data.id}`, requestOptions)
}

export function getSource(id) {
    return apiHelper(API_URL).get(`/${MODULE.SOURCE}/${id}`)
}

export function updateSource(data) {
    const requestOptions = {
        product_uuid: data.productID,
        source_uuid: data.sourceID,
        remark: data.remark,
    }
    return apiHelper(API_URL).put(`/${MODULE.SOURCE}/${data.id}`, requestOptions)
}

export function createSource(data) {
    const requestOptions = {
        product_uuid: data.productID,
        source_uuid: data.sourceID,
        remark: data.remark,
    }

    return apiHelper(API_URL).post(`/${MODULE.SOURCE}`, requestOptions)
}